import { observable, action } from "mobx";
import { PersistentStore } from "./../Stores/PersistentStore"


const maxRecentFiles: number = 10;

export class EPubFileSetting {
	guid: string;
	zoom: number;
	target: string;
	scrollX: number;
	scrollY: number;
}

class EPubFileSettingsStoreImpl extends PersistentStore {

	constructor() {
		super("epubFileSettings");
		this.loadAsync();
	}

	@observable files: EPubFileSetting[] = [];

	public getSettings(fileId: string): EPubFileSetting {
		for (var i = 0; i < this.files.length; i++) {
			let item = this.files[i];
			if (item.guid === fileId) {
				return item;
			}
		}
		return null;
	}

	@action public addSettings(settings: EPubFileSetting): void {
		let temp: EPubFileSetting[] = [];
		temp.push(settings);
		for (let i = 0; i < this.files.length && temp.length < maxRecentFiles; i++) {
			let item = this.files[i];
			if (item.guid !== settings.guid) {
				temp.push(item);
			}
		}
		this.files = temp;
	}
}

export var EPubFileSettingsStore = new EPubFileSettingsStoreImpl();